<template>
  <div class="center">
    <v-dialog
      v-model="searchDetailDialogModel"
      max-width="70%"
    >
      <v-col
        text-md-center
        style="position: relative"
      >
        <v-container
          fluid
          class="pa-8 detail-dialog"
          style="position: relative; background-color: #eee; max-height: calc(100vh - 48px); overflow: auto;"
        >
          <div
            v-if="hasPediatricDepartment"
            class="d-flex p-searchDetail"
          >
            <div class="py-3 px-1 p-searchDetail__key">
              <div class="p-searchDetail__key__title">
                <b>年齢</b>
              </div>
              <div class="p-searchDetail__key__caption">
                子どもの年齢
              </div>
              <div class="p-searchDetail__key__department-label">
                小児科のみ
              </div>
            </div>
            <div class="py-3 px-1 p-searchDetail__input">
              <ChildAgeRangeSlider v-model="childAgeSliderModel" />
            </div>
          </div>

          <div
            v-if="hasPediatricDepartment"
            class="d-flex p-searchDetail"
          >
            <div class="py-3 px-1 p-searchDetail__key">
              <div class="p-searchDetail__key__title">
                <b>性別</b>
              </div>
              <div class="p-searchDetail__key__caption">
                子どもの性別
              </div>
              <div class="p-searchDetail__key__department-label">
                小児科のみ
              </div>
            </div>
            <div class="py-3 px-1 d-flex flex-wrap p-searchDetail__input">
              <div
                v-for="option in childGenderOptions"
                :key="option.value"
              >
                <v-checkbox
                  v-model="childGendersModel"
                  :value="option.value"
                  :label="option.text"
                  class="ma-2"
                  hide-details
                />
              </div>
            </div>
          </div>


          <div class="d-flex p-searchDetail">
            <div class="py-3 px-1 p-searchDetail__key">
              <div class="p-searchDetail__key__title">
                <b>回答者名</b>
              </div>
              <div class="p-searchDetail__key__caption">
                回答者氏名<br>(部分一致)
              </div>
            </div>
            <div class="py-3 px-1 d-flex flex-wrap p-searchDetail__input">
              <DoctorNameInput
                :family-name="doctorFamilyName"
                :first-name="doctorFirstName"
                :disabled="doctorId != null"
                :field-attrs="{ class: 'pt-1 ml-2 mr-6', style: 'max-width: 120px;' }"
                @update:family-name="doctorFamilyNameModel = $event"
                @update:first-name="doctorFirstNameModel = $event"
              />
            </div>
          </div>

          <div class="text-center">
            <v-btn
              color="grey-darken-4"
              density="comfortable"
              @click="searchDetailDialogModel = false"
            >
              完了
            </v-btn>
          </div>
        </v-container>
        <v-btn
          position="absolute"
          class="icon-button"
          color="gray-lighten-4"
          fab
          size="x-small"
          @click="searchDetailDialogModel = false"
        >
          ×
        </v-btn>
      </v-col>
    </v-dialog>

    <v-dialog
      v-model="optionDialogModel"
      max-width="70%"
    >
      <v-col
        text-md-center
        style="position: relative"
      >
        <v-container
          fluid
          class="pa-8 detail-dialog"
          style="position: relative; background-color: #eee; max-height: calc(100vh - 48px); overflow: auto;"
        >
          <div
            class="d-flex p-searchDetail"
          >
            <div class="py-3 px-1 p-searchDetail__key">
              <div class="p-searchDetail__key__title">
                <b>検索除外設定</b>
              </div>
            </div>
            <div class="py-3 px-1 d-flex flex-wrap p-searchDetail__input">
              <v-radio-group
                v-model="excludeModeModel"
                hide-details
                class="ma-2"
              >
                <v-radio
                  label="通常（検索から除外された事例は表示しない）"
                  value="without_exclude"
                />
                <v-radio
                  label="除外中の事例のみ"
                  value="only_exclude"
                />
                <v-radio
                  label="全ての事例"
                  value="with_exclude"
                />
              </v-radio-group>
            </div>
          </div>
        </v-container>
      </v-col>
    </v-dialog>

    <v-container
      fluid
      class="p-searchConditions bg-grey-lighten-3"
    >
      <v-row
        :dense="true"
        style="border-bottom: 1px solid #ddd;"
      >
        <v-col cols="3">
          <div class="pa-2">
            <b>相談員種別</b>
          </div>
        </v-col>
        <v-col cols="9">
          <div class="d-flex flex-wrap">
            <v-checkbox
              v-for="option in departmentTypeOptions"
              :key="option.value"
              v-model="departmentTypesModel"
              :value="option.value"
              :label="option.text"
              class="mt-1 mr-3 c-checkbox--mini"
              density="compact"
              hide-details
            />
          </div>
          <OnlyMyAnswerCheckbox
            v-model="doctorIdModel"
            :current-doctor="currentDoctor"
          />
        </v-col>
      </v-row>

      <v-row
        :dense="true"
        class="pt-2"
      >
        <v-col cols="3">
          <div class="pa-2">
            <b>キーワード</b>
          </div>
        </v-col>
        <v-col cols="9">
          <v-text-field
            v-model="answerKeywordsModel"
            density="compact"
            hide-details
            class="pa-0"
            placeholder="スペース区切り キーワード"
          />
        </v-col>
      </v-row>

      <v-row
        :dense="true"
        class="pt-2"
        style="border-top: 1px solid #ddd;"
      >
        <v-col cols="3">
          <div class="pa-2">
            <b>暫定診断</b>
          </div>
        </v-col>
        <v-col cols="9">
          <Icd10KeywordInput
            v-model="icd10KeywordModel"
            input-id="icd10SearchField"
            class="pa-0"
            placeholder="診断名を検索"
          />
        </v-col>
      </v-row>

      <v-row style="border-top: 1px solid #ddd; border-bottom: 1px solid #ddd;">
        <v-col cols="3">
          <div class="pa-2">
            <b>追加条件</b>
          </div>
        </v-col>
        <v-col cols="9">
          <div class="py-2">
            <div v-if="displayQuery.length > 0">
              {{ displayQuery }}
            </div>
            <a
              style="cursor: pointer;"
              @click="searchDetailDialogModel = true"
            >
              ＋ 設定する
            </a>
          </div>
        </v-col>
      </v-row>

      <v-row
        v-if="isOperatorDoctor"
        style="border-bottom: 1px solid #ddd;"
      >
        <v-col cols="3">
          <div class="pa-2">
            <b>管理者向け</b>
          </div>
        </v-col>
        <v-col cols="9">
          <div class="py-2">
            <div v-if="displayOption.length > 0">
              {{ displayOption }}
            </div>
            <a
              style="cursor: pointer;"
              @click="optionDialogModel = true"
            >
              ＋ 設定する
            </a>
          </div>
        </v-col>
      </v-row>

      <v-row :dense="true">
        <v-col class="text-center">
          <v-btn
            color="grey-darken-4"
            density="comfortable"
            :disabled="departmentTypesModel.length === 0"
            @click="onSearchClick"
          >
            検索
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import ChildAgeRangeSlider from "../../../shared/ui/ChildAgeRangeSlider.vue";
import Icd10KeywordInput from "../../../shared/ui/Icd10KeywordInput.vue";
import DoctorNameInput from "../../../shared/ui/DoctorNameInput.vue";
import OnlyMyAnswerCheckbox from "../../../shared/ui/OnlyMyAnswerCheckbox.vue";

export default {
  name: "AnytimeConsultationSearchConditionsWidget",
  components: {
    ChildAgeRangeSlider,
    Icd10KeywordInput,
    DoctorNameInput,
    OnlyMyAnswerCheckbox
  },
  props: {
    searchDetailDialog: {
      type: Boolean,
      default: false
    },
    optionDialog: {
      type: Boolean,
      default: false
    },
    hasPediatricDepartment: {
      type: Boolean,
      default: false
    },
    departmentTypeOptions: {
      type: Array,
      default: () => []
    },
    childGenderOptions: {
      type: Array,
      default: () => []
    },
    departmentTypes: {
      type: Array,
      default: () => []
    },
    answerKeywords: {
      type: String,
      default: ""
    },
    icd10Keyword: {
      type: String,
      default: ""
    },
    childAgeSlider: {
      type: Array,
      default: () => [0, 35]
    },
    childGenders: {
      type: Array,
      default: () => []
    },
    doctorFamilyName: {
      type: String,
      default: ""
    },
    doctorFirstName: {
      type: String,
      default: ""
    },
    doctorId: {
      type: Number,
      default: null
    },
    currentDoctor: {
      type: Object,
      default: null
    },
    isOperatorDoctor: {
      type: Boolean,
      default: false
    },
    excludeMode: {
      type: String,
      default: "without_exclude"
    },
    displayQuery: {
      type: String,
      default: ""
    },
    displayOption: {
      type: String,
      default: ""
    }
  },
  emits: [
    "search",
    "update:previous-search-query",
    "update:search-detail-dialog",
    "update:option-dialog",
    "update:department-types",
    "update:answer-keywords",
    "update:icd10-keyword",
    "update:child-age-slider",
    "update:child-genders",
    "update:doctor-family-name",
    "update:doctor-first-name",
    "update:doctor-id",
    "update:exclude-mode"
  ],
  data: () => ({
    previousSearchQuery: null
  }),
  computed: {
    searchDetailDialogModel: {
      get() {
        return this.searchDetailDialog;
      },
      set(value) {
        this.$emit("update:search-detail-dialog", value);
      }
    },
    optionDialogModel: {
      get() {
        return this.optionDialog;
      },
      set(value) {
        this.$emit("update:option-dialog", value);
      }
    },
    departmentTypesModel: {
      get() {
        return this.departmentTypes;
      },
      set(value) {
        this.$emit("update:department-types", value);
      }
    },
    answerKeywordsModel: {
      get() {
        return this.answerKeywords;
      },
      set(value) {
        this.$emit("update:answer-keywords", value);
      }
    },
    icd10KeywordModel: {
      get() {
        return this.icd10Keyword;
      },
      set(value) {
        this.$emit("update:icd10-keyword", value);
      }
    },
    childAgeSliderModel: {
      get() {
        return this.childAgeSlider;
      },
      set(value) {
        this.$emit("update:child-age-slider", value);
      }
    },
    childGendersModel: {
      get() {
        return this.childGenders;
      },
      set(value) {
        this.$emit("update:child-genders", value);
      }
    },
    doctorFamilyNameModel: {
      get() {
        return this.doctorFamilyName;
      },
      set(value) {
        this.$emit("update:doctor-family-name", value);
      }
    },
    doctorFirstNameModel: {
      get() {
        return this.doctorFirstName;
      },
      set(value) {
        this.$emit("update:doctor-first-name", value);
      }
    },
    doctorIdModel: {
      get() {
        return this.doctorId;
      },
      set(value) {
        this.$emit("update:doctor-id", value);
      }
    },
    excludeModeModel: {
      get() {
        return this.excludeMode;
      },
      set(value) {
        this.$emit("update:exclude-mode", value);
      }
    }
  },
  methods: {
    buildSearchQuerySnapshot() {
      const departmentTypeMap = {
        1: "pediatrician",
        2: "obstetrician",
        3: "midwife"
      };

      const departmentTypes = (this.departmentTypesModel || [])
        .map((type) => departmentTypeMap[Number(type)])
        .filter(Boolean);

      return {
        departmentTypes,
        doctorFamilyName: this.doctorFamilyNameModel || "",
        doctorFirstName: this.doctorFirstNameModel || "",
        icd10Keyword: this.icd10KeywordModel || "",
        answerKeywords: this.answerKeywordsModel || "",
        answerKeywordScopes: ["answer"],
        childSex: this.hasPediatricDepartment ? (this.childGendersModel || []) : [],
        childAgeRange: this.hasPediatricDepartment
          ? {
            gte: Number(this.childAgeSliderModel?.[0] ?? 0),
            lte: Number(this.childAgeSliderModel?.[1] ?? 35)
          }
          : {},
        inPregnancy: [],
        userAgeRank: [],
        weeksOfPregnancyRank: [],
        monthsOfPostpartumRank: [],
        userInterest: [],
        sortRules: [{ column: "score", direction: "desc" }],
        displayScore: false,
        doctorId: this.doctorIdModel || null,
        exclude_mode: this.isOperatorDoctor ? this.excludeModeModel : "without_exclude"
      };
    },
    onSearchClick() {
      this.previousSearchQuery = this.buildSearchQuerySnapshot();
      this.$emit("update:previous-search-query", this.previousSearchQuery);
      this.$emit("search");
    }
  }
};
</script>

<style lang="scss">
.c-checkbox--mini {
  .v-label {
    font-size: 0.8em !important;
  }

  .v-input--selection-controls__input {
    margin-right: 0px !important;
  }

  .v-input--selection-controls__ripple {
    height: 31px;
    width: 31px;
    top: calc(50% - 23px);
  }

  .v-icon {
    font-size: 21px !important;
  }
}

.p-searchConditions {
  .v-messages {
    min-height: 0px !important;
  }

  .v-input__slot {
    margin: 0;
  }
}

.p-searchDetail {
  & + & {
    border-top: 1px solid #ccc;
  }

  &__key {
    width: 120px;
    display: flex;
    flex-direction: column;
    justify-content: center;

    &__caption {
      font-size: 0.7em;
      color: #666;
    }

    &__department-label {
      margin-top: 2px;
      font-size: 0.7em;
      color: #666;
      font-weight: 600;
    }
  }

  &__input {
    width: calc(100% - 120px);
  }
}
</style>
